import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import axios from 'axios';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import { Grid } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import Tooltip from '@material-ui/core/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { CommonConfig } from '../../../config/common-config';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';
import PreviewImage from '../../../assets/previewImage.png';
import downloadImage from '../../../assets/downloadImage.png';
import PreviewModal from '../../../components/modal/previewModal';
import './styles.css';
import TabList from '../../../components/checklistTab/tabList';
import { setSelectedStageId } from '../../services/store/actions';
import buttonDisable from '../../../components/disableField/buttonDisable';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { userType } from '../../../config/usertypeValue';
import deleteImage from '../../../assets/deleteImage.png';

const useStyles = makeStyles((theme) => ({
    root: {
        boxShadow: '0px 5px 10px #efefef !important',
        borderRadius: '8px',
        minHeight: '300px',
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        color: '#727272',
        fontSize: '20px',
        fontFamily: 'Rubik',
        fontWeight: '500',
        marginBottom: '20px',
    },
    pos: {
        marginBottom: 12,
    },
    rootCard: {
        marginBottom: '20px',
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        '& > *': {
            margin: theme.spacing(1),
        },
    },

    bottomLine: {
        padding: '0',
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    inlineDisplayFont: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 20px',
            color: '#7779ba',
            marginTop: '-10px',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        top: '-30px',
        fontFamily: 'Rubik !important',
    },
    inlinebutton: {
        padding: '0',
        margin: '0',
        '& li': {
            listStyle: 'none',
            display: 'inline-block',
            marginRight: '15px',
        },
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    fileName: {
        textAlign: 'center',
    },
    toolTipFont: {
        fontFamily: 'Rubik !important',
        fontSize: '12px',
    },
    otherstoolTipFont: {
        fontFamily: 'Rubik !important',
        fontSize: '12px',
    },
    noteMsg: {
        color: '#4c4c4c',
        marginRight: '68px',
        fontSize: '11px',
        marginTop: '10px',
        fontFamily: 'Rubik !important',
    },
    downloadImg: {
        width: '25px',
        height: '26px',
        position: 'relative',
        top: '6px',
        left: '6px',
    },
    btnView: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        margin: '0px !important',
        // width: '45%'
    },
    pointerEvents: {
        pointerEvents: 'none !important',
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
        background: 'rgba(0, 0, 0, 0.12) !important',
        color: 'rgba(0, 0, 0, 0.12) !important',
    },
    pointer: {
        pointerEvents: 'none !important',
    },
}));

export default function IMCFinalDocument() {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch({});
    const [state, setState] = React.useState({
        checkedA: true,
    });
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [URLValue, setURLValue] = useState();
    const [uploadSuccessfully, setUploadSuccessfully] = useState('');
    const [selectedFileData, setSelectedFileData] = useState(null);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [attachedFilename, setAttachedFilename] = useState('');
    const [uploadDisable, setUploadDisable] = useState(true);
    // const [coreTeamFilename, setCoreTeamFilename] = useState('');
    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;
    const [handleOpen, setHandleOpen] = useState(false);
    const [filename, setFilename] = useState('');
    const [isfileInvalid, setIsfileInvalid] = useState('');
    const [isDisable, setIsDisable] = useState(true);
    const [clearData, setClearData] = useState('');
    const [showBtnLoader, setShowBtnLoader] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [visible, setVisible] = React.useState(false);
    // const coreFilename = [];
    const [downloadFile, setDownloadFile] = useState('');
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const [finalView, setFinalView] = useState(false);
    const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const [fileList, setFileList] = useState([]);
    const [fileListList, setFileListList] = useState([]);
    const [fileIndex, setFileIndex] = useState();
    const [isChecked, setIsChecked] = useState(true);

    useEffect(() => {
        // const tempFileList = [];
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/final-computation/by-serviceId/${tennantnameValue}/${serviceIdValue}`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response && response.data) {
                    if (response.data.finalComputationDocument && response.data.finalComputationDocument.length) {
                        setFileListList(response.data.finalComputationDocument);
                        response.data.finalComputationDocument.filter((ele) => {
                            let temp = { fileUrl: ele, fileName: ele.substring(ele.lastIndexOf('/') + 1), filePath: ele };
                            fileList.push(temp);
                            setIsChecked(false);
                            setFinalView(response.data.paidTax);
                        });
                    }
                }
            })
            .catch((error) => {});
    }, [bearerToken]);

    const isFileUpload = (event, selectorFiles, index) => {
        if (selectorFiles) {
            const pattern = new RegExp('^.+.(pdf)$');
            setFilename(selectorFiles[0].name);
            handleInputChange(event, index, selectorFiles[0].name);
            setFileIndex(index);
            if (pattern.test(selectorFiles[0].name)) {
                setIsfileInvalid('');
                setUploadDisable(false);
                if (selectorFiles[0].size / 1024 > 1024 * 10) {
                    setIsfileInvalid('Please select the file size less than 10MB');
                    setIsDisable(true);
                } else {
                    setSelectedFileData(selectorFiles[0]);
                }
            } else {
                setIsfileInvalid('Please select valid file format i.e pdf');
                setIsDisable(true);
            }
        }
    };

    const fileUpload = () => {
        const data = new FormData();
        data.append('file', selectedFileData);
        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/s3upload/${tennantnameValue}/${serviceIdValue}/myimage`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data) {
                    setURLValue(response.data);
                    setAttachedFilename(filename);
                    setIsDisable(false);
                    setIsChecked(false);
                    setUploadSuccessfully('Uploaded a file successfully');
                    setTimeout(() => {
                        handleClose();
                        setAttachedFile(response.data);
                    }, 500);
                }
            })
            .catch((error) => {
                if (error && error.response && error.response.data) {
                    setIsDisable(true);
                }
            });
    };

    const handleClick = () => {
        setHandleOpen(true);
        setClearData('');
        setUploadSuccessfully('');
        setUploadDisable(true);
        handleAddClick();
    };

    const handleClose = () => {
        setHandleOpen(false);
        setIsfileInvalid('');
        setFilename(null);
    };

    const handleChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };

    const initialValues = {
        URL: '',
    };

    const handleCheckChange = (event) => {
        setFinalView(event.target.checked);
    };

    const handleSubmit = (values) => {
        setShowBtnLoader(true);
        let IMCTeamArr = [];
        fileList.filter((ele) => {
            IMCTeamArr.push(ele.filePath);
        });

        const data = {
            serviceId: serviceIdValue,
            remarks: 'Remarks',
            finalDocumentAndReports: {
                finalComputationDocument: IMCTeamArr,
                itrAcknowledgement: '',
                taxChalanOrAcknowledgement: '',
                transferToAccount: false,
                payonline: true,
                stage: 'finalDocumentAndReports',
                descriptionForInvoice: 'descriptionForInvoice',
                amountForInvoice: '1111',
                reports: 'Structure is not finalized',
                paidTax: finalView === null ? false : finalView,
            },
        };

        axios
            .post(`${CommonConfig.dev.baseUrl1}/api/itr/final-computation/create/${tennantnameValue}`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response.data === 'SUCCESS') {
                    setShowBtnLoader(false);
                    setSuccessPop(true);
                    setTimeout(() => {
                        setSuccessPop(false);
                    }, 3000);
                    if (finalView) {
                        dispatch(setSelectedStageId(21));
                        userType.value = 'Tax Payment and Filing';
                        setTimeout(() => {
                            history.push({
                                pathname: '/menu/imc-final-doc-approval',
                            });
                        }, 3000);
                    } else {
                        setTimeout(() => {
                            history.push({
                                pathname: '/menu/openservice',
                            });
                        }, 3000);
                    }
                }
            })
            .catch((error) => {
                const errorMessage = error.response;
                setErrorMsgGenerateRecceipt(errorMessage.data.message);
            });
    };

    const handleModalClose = () => {
        setVisible(false);
    };

    const handlePreviewModal = (file) => {
        setDownloadFile(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`);
        setShowBtnLoader(true);
        setTimeout(() => {
            setShowBtnLoader(false);
            setVisible(true);
        }, 1000);
    };

    const navigateBack = () => {
        let data = {
            serviceId: serviceIdValue,
        };

        axios
            .put(`${CommonConfig.dev.baseUrl1}/api/itr/draft-statements/final-draft/${tennantnameValue}`, data, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                if (response) {
                    dispatch(setSelectedStageId(18));
                    history.push({
                        pathname: '/menu/imc-draft-document',
                        state: { path: 'openservices' },
                    });
                }
            })
            .catch((error) => {});
    };

    const useStylesBootstrap = makeStyles((theme) => ({
        arrow: {
            color: '#e5e5e5',
        },
        tooltip: {
            backgroundColor: '#e5e5e5',
            color: '#444',
        },
    }));

    const setAttachedFile = (data) => {
        const list = [...fileList];
        list[fileIndex]['filePath'] = data;
        setFileList(list);
    };

    // handle input change
    const handleInputChange = (e, index, name) => {
        const list = [...fileList];
        list[index]['fileUrl'] = e.target.value;
        list[index]['fileName'] = name;
        setFileList(list);
    };

    // handle click event of the Add file list
    const handleAddClick = () => {
        setFileList([...fileList, { fileUrl: '', fileName: '', filePath: '' }]);
    };

    // handle click event of the Remove button
    const handleRemoveClick = (index) => {
        const list = [...fileList];
        list.splice(index, 1);
        setFileList(list);
        if (!list.length) {
            setIsDisable(true);
            setIsChecked(true);
        }
        // setURLValueData(list);
    };

    const downloadCoreFile = (file) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s3download?fileName=${file}`, {
                // method: 'GET',
                headers: {
                    Authorization: bearerToken,
                },
                responseType: 'blob',
            })

            .then((response) => {
                const link = document.createElement('a');

                link.href = response.config.url;
                link.setAttribute('download', response.config.url);
                // Start download
                link.click();
            });
    };

    function BootstrapTooltip(props) {
        const classes = useStylesBootstrap();

        return <Tooltip arrow placement="right" classes={classes} {...props} />;
    }

    return (
        <div>
            <TabList />
            {successpop ? (
                <SuccessPopUp
                    open={successpop}
                    showSuccess={successpop}
                    handleClose={handleClose}
                    title="Final statements uploaded successfully"
                />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}

            <Formik initialValues={initialValues} onSubmit={(values) => handleSubmit(values)} enableReinitialize>
                {(formik) => {
                    return (
                        <form className="itecform" onSubmit={formik.handleSubmit}>
                            <Card className={classes.root}>
                                <CardContent>
                                    <form className="itecform" onSubmit={formik.handleSubmit}>
                                        <Grid container spacing={3}>
                                            <Grid item xs={12} sm={12}>
                                                <Typography className="final-doc-title">Final Statement</Typography>
                                            </Grid>
                                            <Grid item xs={12} sm={12}>
                                                <FormControl fullWidth className="mt50 mb50">
                                                    <BootstrapTooltip
                                                        title={
                                                            <React.Fragment>
                                                                <Typography color="inherit" className={classes.toolTipFont}>
                                                                    Attach final statement and other documents, if
                                                                    <br /> any which you would wish to share with client
                                                                    <br /> as a part of deliverable. In the subsequent
                                                                    <br /> stages, ITR acknowledgement and tax challan if
                                                                    <br /> any, will get added to the final deliverable.
                                                                </Typography>
                                                            </React.Fragment>
                                                        }
                                                    >
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            size="small"
                                                            className={classes.button}
                                                            value={formik.values.URL}
                                                            onClick={handleClick}
                                                            onBlur={formik.handleBlur}
                                                            disabled={
                                                                buttonDisable(stageId, userType.value) ||
                                                                usertype === 'Other employee users' ||
                                                                finalView
                                                            }
                                                        >
                                                            Upload Final Statement<span style={{ color: '#ff0a047a' }}>*</span>
                                                        </Button>
                                                    </BootstrapTooltip>
                                                    <div style={{ textAlign: 'center', marginTop: '-34px', marginLeft: '7px' }}>
                                                        <div className={classes.noteMsg}>
                                                            <strong>Note:</strong> Attach only PDF
                                                        </div>
                                                    </div>

                                                    <span
                                                        style={{
                                                            paddingBottom: '12px',
                                                            textAlign: 'center',
                                                            display: 'flex',
                                                            flexWrap: 'wrap',
                                                        }}
                                                    >
                                                        {stageId === 19
                                                            ? fileList &&
                                                              fileList.map((file, index) => {
                                                                  return (
                                                                      <span style={{ marginRight: '12px' }}>
                                                                          {!isChecked && file.fileName ? (
                                                                              <span
                                                                                  style={{
                                                                                      padding: '5px 10px 5px 10px',
                                                                                      display: 'flex',
                                                                                      width: '252px',
                                                                                      borderRadius: '5px',
                                                                                      background: '#e8e7e7',
                                                                                      marginBottom: '10px',
                                                                                  }}
                                                                              >
                                                                                  <span
                                                                                      style={{
                                                                                          marginRight: '8px',
                                                                                          paddingTop: '6px',
                                                                                          width: '61%',
                                                                                      }}
                                                                                      className="fileName"
                                                                                  >
                                                                                      {file.fileName.substring(0, 15)}
                                                                                      {file.fileName.length > 15 ? '...' : ''}
                                                                                  </span>
                                                                                  <div
                                                                                      style={{
                                                                                          width: '25%',
                                                                                          display: file ? 'flex' : 'none',
                                                                                      }}
                                                                                  >
                                                                                      <span
                                                                                          onClick={() => handlePreviewModal(file.filePath)}
                                                                                      >
                                                                                          <Tooltip title="Preview">
                                                                                              <img
                                                                                                  src={PreviewImage}
                                                                                                  alt="PreviewImage"
                                                                                                  className="fileView"
                                                                                              />
                                                                                          </Tooltip>
                                                                                      </span>
                                                                                      <span
                                                                                          className={
                                                                                              buttonDisable(stageId, userType.value)
                                                                                                  ? classes.pointer
                                                                                                  : ''
                                                                                          }
                                                                                          onClick={() => handleRemoveClick(index)}
                                                                                      >
                                                                                          {stageId === 19 ? (
                                                                                              <Tooltip title="Delete">
                                                                                                  <img
                                                                                                      src={deleteImage}
                                                                                                      alt="deleteImage"
                                                                                                      className="closeImg"
                                                                                                  />
                                                                                              </Tooltip>
                                                                                          ) : (
                                                                                              ''
                                                                                          )}
                                                                                      </span>
                                                                                      <span onClick={() => downloadCoreFile(file.filePath)}>
                                                                                          <Tooltip title="Download">
                                                                                              <img
                                                                                                  src={downloadImage}
                                                                                                  alt="downloadImage"
                                                                                                  className={classes.downloadImg}
                                                                                              />
                                                                                          </Tooltip>
                                                                                      </span>
                                                                                  </div>
                                                                              </span>
                                                                          ) : null}
                                                                          <PreviewModal
                                                                              fileSource={downloadFile}
                                                                              visibleClose={visible}
                                                                              handleModalClose={handleModalClose}
                                                                          />
                                                                          <Dialog
                                                                              onClose={handleClose}
                                                                              PaperProps={{
                                                                                  className: 'QandADailogBox',
                                                                                  style: { padding: '20px' },
                                                                              }}
                                                                              aria-labelledby="form-dialog-title"
                                                                              open={handleOpen}
                                                                              clear={clearData}
                                                                          >
                                                                              <DialogTitle id="form-dialog-title">Upload File</DialogTitle>
                                                                              <DialogContent
                                                                                  style={{
                                                                                      textAlign: 'center',
                                                                                  }}
                                                                              >
                                                                                  <Button
                                                                                      className="btnOrange"
                                                                                      variant="outlined"
                                                                                      component="label"
                                                                                      color="default"
                                                                                  >
                                                                                      <i className="btnIcon">
                                                                                          <FontAwesomeIcon icon={faPlus} />
                                                                                      </i>{' '}
                                                                                      Add File
                                                                                      <input
                                                                                          onChange={(e) =>
                                                                                              isFileUpload(e, e.target.files, index)
                                                                                          }
                                                                                          type="file"
                                                                                          style={{
                                                                                              display: 'none',
                                                                                          }}
                                                                                          accept="application/pdf"
                                                                                      />
                                                                                  </Button>
                                                                                  {/* {!isfileInvalid && filename ? ( */}
                                                                                  {filename ? (
                                                                                      <p className="fileName">
                                                                                          {filename.substring(0, 15) + '...'}
                                                                                      </p>
                                                                                  ) : null}

                                                                                  {filename ? (
                                                                                      isfileInvalid && isfileInvalid.length > 0 ? (
                                                                                          <p className="noteCss">Note: {isfileInvalid}</p>
                                                                                      ) : (
                                                                                          ''
                                                                                      )
                                                                                  ) : null}
                                                                              </DialogContent>
                                                                              {/* <p className="fileNameRed">{isfileInvalid}</p> */}
                                                                              <p className="fileNameGreen">{uploadSuccessfully}</p>
                                                                              <DialogActions className="paddingBtm txtCenter">
                                                                                  <Button
                                                                                      className="btnBluepop"
                                                                                      onClick={fileUpload}
                                                                                      variant="contained"
                                                                                      disabled={uploadDisable}
                                                                                      component="label"
                                                                                      color="default"
                                                                                  >
                                                                                      Upload
                                                                                  </Button>
                                                                                  <Button
                                                                                      className="btnBluepop"
                                                                                      disabled={uploadSuccessfully.length}
                                                                                      onClick={handleClose}
                                                                                      variant="contained"
                                                                                      component="label"
                                                                                      color="default"
                                                                                  >
                                                                                      Cancel
                                                                                  </Button>
                                                                              </DialogActions>
                                                                          </Dialog>
                                                                      </span>
                                                                  );
                                                              })
                                                            : fileListList &&
                                                              fileListList.map((file, index) => {
                                                                  return (
                                                                      <span style={{ marginRight: '12px' }}>
                                                                          {!isChecked && file ? (
                                                                              <span
                                                                                  style={{
                                                                                      padding: '5px 10px 5px 10px',
                                                                                      display: 'flex',
                                                                                      width: '252px',
                                                                                      borderRadius: '5px',
                                                                                      background: '#e8e7e7',
                                                                                      marginBottom: '10px',
                                                                                  }}
                                                                              >
                                                                                  <span
                                                                                      style={{
                                                                                          marginRight: '8px',
                                                                                          paddingTop: '6px',
                                                                                          width: '61%',
                                                                                      }}
                                                                                      className="fileName"
                                                                                  >
                                                                                      {file
                                                                                          .substring(file.lastIndexOf('/') + 1)
                                                                                          .substring(0, 15)}
                                                                                      {file.substring(file.lastIndexOf('/') + 1).length > 15
                                                                                          ? '...'
                                                                                          : ''}
                                                                                  </span>
                                                                                  <div
                                                                                      style={{
                                                                                          width: '25%',
                                                                                          display: file ? 'flex' : 'none',
                                                                                      }}
                                                                                  >
                                                                                      <span onClick={() => handlePreviewModal(file)}>
                                                                                          <Tooltip title="Preview">
                                                                                              <img
                                                                                                  src={PreviewImage}
                                                                                                  alt="PreviewImage"
                                                                                                  className="fileView"
                                                                                              />
                                                                                          </Tooltip>
                                                                                      </span>
                                                                                      <span
                                                                                          className={
                                                                                              buttonDisable(stageId, userType.value)
                                                                                                  ? classes.pointer
                                                                                                  : ''
                                                                                          }
                                                                                          onClick={() => handleRemoveClick(index)}
                                                                                      >
                                                                                          {stageId === 19 ? (
                                                                                              <Tooltip title="Delete">
                                                                                                  <img
                                                                                                      src={deleteImage}
                                                                                                      alt="deleteImage"
                                                                                                      className="closeImg"
                                                                                                  />
                                                                                              </Tooltip>
                                                                                          ) : (
                                                                                              ''
                                                                                          )}
                                                                                      </span>
                                                                                      <span onClick={() => downloadCoreFile(file)}>
                                                                                          <Tooltip title="Download">
                                                                                              <img
                                                                                                  src={downloadImage}
                                                                                                  alt="downloadImage"
                                                                                                  className={classes.downloadImg}
                                                                                              />
                                                                                          </Tooltip>
                                                                                      </span>
                                                                                  </div>
                                                                              </span>
                                                                          ) : null}
                                                                          <PreviewModal
                                                                              fileSource={downloadFile}
                                                                              visibleClose={visible}
                                                                              handleModalClose={handleModalClose}
                                                                          />
                                                                      </span>
                                                                  );
                                                              })}
                                                    </span>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={12} style={{ paddingBottom: '0px', paddingLeft: '18px' }}>
                                                <FormControlLabel
                                                    style={{ fontFamily: 'Rubik !important' }}
                                                    control={
                                                        <Checkbox
                                                            disabled={
                                                                // fileList && fileList[0] && fileList[0].fileName
                                                                //     ? true
                                                                //     : false ||
                                                                buttonDisable(stageId, userType.value)
                                                            }
                                                            checked={finalView}
                                                            onChange={handleCheckChange}
                                                            name="checkedA"
                                                            color="primary"
                                                        />
                                                    }
                                                    label="Incase there are no taxes to be paid, kindly check the box"
                                                />
                                            </Grid>
                                        </Grid>
                                    </form>
                                </CardContent>
                            </Card>

                            <div className="footer-button">
                                <ul>
                                    <li>
                                        <Button
                                            color="primary"
                                            className="buttonnext txt-cap"
                                            onClick={() => {
                                                navigateBack();
                                            }}
                                            disabled={buttonDisable(stageId, userType.value)}
                                        >
                                            Back
                                        </Button>
                                    </li>
                                    <li>
                                        <Button
                                            color="primary"
                                            disabled={
                                                buttonDisable(stageId, userType.value) ||
                                                (usertype === 'EM' ? (!finalView ? isDisable : false) : usertype === 'Other employee users')
                                            }
                                            className="buttonnext txt-cap"
                                            type="submit"
                                        >
                                            Submit
                                        </Button>
                                    </li>
                                </ul>
                            </div>
                        </form>
                    );
                }}
            </Formik>
            {showBtnLoader ? (
                <LoaderPopUp
                    showLoader={showBtnLoader}
                    handleClose={handleClose}
                    title="Please wait while approving Tax Payment Document"
                />
            ) : null}
        </div>
    );
}
